// Mock data for Quattro Tavoli - Italienisches Bistro, München
// NOTE: All data below is MOCKED for the frontend-only prototype.

export const restaurant = {
  name: "Quattro Tavoli",
  tagline: "Italienisches Bistro im Herzen Münchens",
  address: "Dreimühlenstraße 10, 80469 München",
  district: "Dreimühlenviertel",
  phone: "+49 89 741 181 57",
  email: "quattrotavoli@gmail.com",
  intro:
    "Das Leben zelebrieren kann man am Besten in der italienischen Gemütlichkeit des Quattro Tavoli. Abschalten, genießen und sich des Lebens freuen – ein kleiner Urlaub im Alltag.",
};

export const hours = [
  { label: "Mittagessen", days: "Montag & Freitag", time: "12:00 – 15:00" },
  { label: "Abendessen", days: "Montag bis Freitag", time: "18:00 – 23:30" },
  { label: "Samstag", days: "Nur geschlossene Gesellschaften", time: "auf Anfrage" },
  { label: "Küche und Take Away", days: "Täglich abholbar", time: "bis 21:30" },
];

export const menuHighlights = [
  {
    id: 1,
    name: "Aperol Spritz",
    category: "Aperitivo",
    desc: "Das Dolce-Vita-Gefühl im Glas – prickelnd, bittersüß, sonnengelb.",
    price: "7,50",
    image:
      "https://images.unsplash.com/photo-1570598912132-0ba1dc952b7d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: 2,
    name: "Insalata Caprese",
    category: "Antipasti",
    desc: "Büffelmozzarella, sonnengereifte Tomaten, frisches Basilikum & Olivenöl.",
    price: "11,90",
    image:
      "https://images.unsplash.com/photo-1592417817098-8fd3d9eb14a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: 3,
    name: "Pasta della Casa",
    category: "Primi",
    desc: "Hausgemachte Pasta, täglich frisch – mit Sugo nach Mamas Rezept.",
    price: "14,50",
    image:
      "https://images.unsplash.com/photo-1498579150354-977475b7ea0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: 4,
    name: "Pizza Napoletana",
    category: "Forno",
    desc: "Luftiger Teig aus dem Steinofen, San-Marzano-Tomaten & Fior di Latte.",
    price: "12,90",
    image:
      "https://images.pexels.com/photos/14966000/pexels-photo-14966000.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=900",
  },
  {
    id: 5,
    name: "Tagliatelle al Ragù",
    category: "Primi",
    desc: "Langsam geschmortes Ragù bolognese auf seidigen Bandnudeln.",
    price: "15,90",
    image:
      "https://images.unsplash.com/photo-1597131628347-c769fc631754?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    id: 6,
    name: "Dolci del Giorno",
    category: "Dolci",
    desc: "Tiramisù, Panna Cotta & mehr – der süße Schlusspunkt jedes Abends.",
    price: "6,90",
    image:
      "https://images.unsplash.com/photo-1556761223-4c4282c73f77?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
];

export const gallery = [
  "Gallery-1.jpeg",
  "Gallery-2.jpeg",
  "Gallery-3.jpeg",
  "Gallery-4.jpeg",
  "Gallery-5.jpeg",
  "Gallery-6.jpeg",
  "Gallery-7.jpeg",
  "Gallery-8.jpeg",
  "Gallery-9.jpeg",
];

// Each review has one text per language: de = Deutsch, it = Italiano, en = English.
// The site shows the one matching the language chosen in the header.
export const testimonials = [
  {
    id: 1,
    author: "Max",
    text: {
      de: "Hier fühlt man sich wie im Urlaub.",
      it: "Qui ti senti come in vacanza.",
      en: "Here you feel like you are on holiday.",
    },
  },
  {
    id: 2,
    author: "Joanna",
    text: {
      de: "So ein tolles Restaurant! Das Personal ist superfreundlich und lustig, die Getränke sind sehr gut und das Essen … einfach köstlich.",
      it: "Che ristorante fantastico! Il personale è super gentile e simpatico, i drink sono molto buoni e il cibo … semplicemente delizioso.",
      en: "Such a great restaurant! The staff is super friendly and funny, the drinks are very good, and the food… simply delicious.",
    },
  },
  {
    id: 3,
    author: "Eleonora",
    text: {
      de: "Was für eine schöne Entdeckung – man fühlt sich wie zu Hause in Italien! Dieses kleine italienische Restaurant ist absolut gemütlich und bietet dank des Service eine familiäre Atmosphäre; die Speisekarte wechselt täglich und orientiert sich an erstklassigen Zutaten.",
      it: "Che bella scoperta, ci si sente come a casa in Italia! Questo piccolo ristorante italiano è davvero accogliente, con un'atmosfera familiare grazie al servizio; il menù cambia ogni giorno in base a ingredienti di altissima qualità.",
      en: "Such a nice discovery, Italian home feeling! This small Italian restaurant is absolutely cozy, a familiar atmosphere thanks to service, menu changes every day depending on very high-quality ingredients. Very recommended.",
    },
  },
  {
    id: 4,
    author: "Alek",
    text: {
      de: "Ein unglaublich authentischer, lebendiger und unterhaltsamer Ort. Köstliches Essen in toller Atmosphäre. Ehrlich gesagt ist es womöglich der beste Italiener der Stadt.",
      it: "Un posto incredibilmente autentico, vivace e divertente. Cibo delizioso in un'atmosfera fantastica. Onestamente, forse è il miglior italiano della città.",
      en: "An incredibly authentic, lively and entertaining place. Delicious food in a great atmosphere. Honestly, it might be the best Italian in the city.",
    },
  },
];

export const navLinks = [
  { key: "nav.about", href: "#about" },
  { key: "nav.gallery", href: "#gallery" },
  { key: "nav.events", href: "/events" },
];
